/*
 * MYHOLDAL breadcrumbs - session trail (Sep 2026).
 *
 * Replaces the Liquid baseline trail with the steps the shopper actually took,
 * e.g. Home > Derma > La Roche-Posay > Product. Stored per tab in
 * sessionStorage; falls back to the baseline whenever the trail can't be
 * trusted (new tab, arrived from Google, header / footer / drawer navigation).
 *
 * Rules when moving forward by an in-page link:
 *  - page (1) < collection (2) < product (3): anything deeper than the new
 *    page is dropped, so Collection > Product > (back to) Collection never
 *    stacks.
 *  - Product -> product (recommendations) replaces the product.
 *  - Revisiting a URL already in the trail (Back button, clicking a crumb)
 *    cuts the trail back to it.
 *  - At most MAX crumbs between Home and the current page.
 */
(function () {
  var nav = document.querySelector('[data-mh-bc]');
  if (!nav) return;

  var KEY = 'mhBcTrail:v1';
  var FRESH = 'mhBcFresh:v1';
  var BY_URL = 'mhBcByUrl:v1';
  var NAV = 'mhBcNav:v1';
  var SEED = 'mhBcSeed:v1';
  var MAX = 3;
  var RANK = { page: 1, blog: 1, search: 1, 'list-collections': 1, collection: 2, article: 2, product: 3 };

  function norm(path) {
    path = (path || '/').replace(/\/+$/, '');
    return path || '/';
  }
  function rank(kind) { return RANK[kind] || 1; }
  function store(key, val) {
    try {
      if (val === null) sessionStorage.removeItem(key);
      else sessionStorage.setItem(key, JSON.stringify(val));
    } catch (e) {}
  }
  function load(key) {
    try { return JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (e) { return null; }
  }

  var current = { u: norm(location.pathname), t: nav.getAttribute('data-title'), k: nav.getAttribute('data-kind') };

  // Baseline from Liquid: every link except Home, then the current page.
  var baseline = [];
  var links = nav.querySelectorAll('.mh-bc__link');
  for (var i = 1; i < links.length; i++) {
    baseline.push({ u: norm(links[i].pathname), t: links[i].textContent.trim(), k: links[i].getAttribute('data-kind') || 'page' });
  }
  baseline.push(current);

  var referrer = null;
  try {
    var r = new URL(document.referrer);
    if (r.origin === location.origin) referrer = norm(r.pathname);
  } catch (e) {}

  var fresh = load(FRESH);
  store(FRESH, null);
  var seed = load(SEED);
  store(SEED, null);

  var saved = load(KEY);
  var trail = Array.isArray(saved) ? saved : [];
  var at = -1;
  for (var j = 0; j < trail.length; j++) if (trail[j].u === current.u) { at = j; }

  // Back / Forward: show the trail this page had when it was last seen.
  var byUrl = load(BY_URL) || {};
  var navType = '';
  try { navType = performance.getEntriesByType('navigation')[0].type; } catch (e) {}

  // Searching is not a step deeper into where you were standing. The referrer
  // still points at the page the search box was opened over, so without this
  // a product opened from a search result hangs off whatever was on screen at
  // the time - "Women > Beauty > MAC COSMETICS > Le Roseau Tote bag".
  var fromSearch = referrer !== null && /(^|\/)search$/.test(referrer);

  if (navType === 'back_forward' && Array.isArray(byUrl[current.u])) {
    trail = byUrl[current.u];
  } else if (fromSearch) {
    trail = baseline;
  } else if (fresh === current.u) {
    // Header / footer / drawer link: a new journey starts here - but the menu
    // itself says where "here" sits, so start from the universe and category
    // the shopper opened rather than from a bare Home > page.
    var seeded = Array.isArray(seed) ? seed.filter(function (c) { return c.u !== current.u; }) : [];
    trail = seeded.length ? seeded.concat([current]) : baseline;
  } else if (at >= 0) {
    trail = trail.slice(0, at);
    trail.push(current);
  } else if (referrer && trail.length && trail[trail.length - 1].u === referrer) {
    while (trail.length) {
      var last = trail[trail.length - 1];
      if (rank(last.k) > rank(current.k) || (last.k === 'product' && current.k === 'product')) trail.pop();
      else break;
    }
    trail.push(current);
  } else {
    trail = baseline;
  }

  if (trail.length > MAX + 1) trail = trail.slice(trail.length - (MAX + 1));
  store(KEY, trail);
  delete byUrl[current.u];
  byUrl[current.u] = trail;
  var keys = Object.keys(byUrl);
  while (keys.length > 40) delete byUrl[keys.shift()];
  store(BY_URL, byUrl);

  // Restored from the back/forward cache: the DOM is already right, but the
  // stored trail must follow this page again.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) store(KEY, trail);
  });

  // The universe crumb already says Women / Men / Kids / Life, so the word
  // repeated inside every child title - "Women > Women Bags > ..." - is noise.
  // Drop it from the crumbs under it, the current page included. Only the
  // label shown changes; the stored trail keeps the real titles so a crumb
  // revisited later still matches by URL.
  var uniPaths = [];
  var uniLinks = document.querySelectorAll('.site-navigation > .site-nav__item.main-menu a[href]');
  for (var u = 0; u < uniLinks.length; u++) uniPaths.push(norm(uniLinks[u].pathname));

  var uniTitle = null;
  for (var v = 0; v < trail.length; v++) {
    if (uniPaths.indexOf(trail[v].u) >= 0) { uniTitle = trail[v].t; break; }
  }
  function label(c) {
    if (!uniTitle || c.t === uniTitle) return c.t;
    var pre = (uniTitle + ' ').toLowerCase();
    if (c.t.toLowerCase().indexOf(pre) === 0) return c.t.slice(pre.length);
    return c.t;
  }

  var list = nav.querySelector('.mh-bc__list');
  var currentItem = list.lastElementChild;
  // keep Home (first) and the current page (last), replace what is between
  while (list.children.length > 2) list.removeChild(list.children[1]);
  trail.slice(0, -1).forEach(function (c) {
    var li = document.createElement('li');
    li.className = 'mh-bc__item';
    var a = document.createElement('a');
    a.className = 'mh-bc__link';
    a.href = c.u;
    a.setAttribute('data-kind', c.k);
    a.textContent = label(c);
    li.appendChild(a);
    list.insertBefore(li, currentItem);
  });
  var currentLabel = currentItem.querySelector('.mh-bc__current');
  if (currentLabel) currentLabel.textContent = label(trail[trail.length - 1]);

  // Phones: the list scrolls sideways. Stay at the start so Home and the
  // parent crumb are the ones on screen - scrolling to the end hid both and
  // the trail appeared to begin mid-path. The current page is the page title
  // directly underneath, so losing its tail to the ellipsis costs nothing.

  // Header category row (BRANDS, CLOTHING...): underline the one this journey
  // belongs to. 1) the category clicked to start the journey, 2) else the
  // deepest trail page that one of the menus links to, 3) else Liquid's guess.
  function navToken(li) {
    for (var c = 0; c < li.classList.length; c++) {
      if (li.classList[c].indexOf('site-nav__item-') === 0) return li.classList[c];
    }
    return null;
  }
  var navItems = [].slice.call(document.querySelectorAll('.site-navigation > .site-nav__item:not(.main-menu)'));
  if (navItems.length) {
    var pick = null;
    var navState = load(NAV);
    var inTrail = function (u) { return trail.some(function (c) { return c.u === u; }); };
    if (navState && navState.t && inTrail(navState.u)) pick = navState.t;
    for (var d = trail.length - 1; d >= 0 && !pick; d--) {
      for (var m = 0; m < navItems.length && !pick; m++) {
        var li = navItems[m];
        var hrefs = [].slice.call(li.querySelectorAll('a[href]')).map(function (x) { return norm(x.pathname); });
        var sum = li.querySelector('summary[data-link]');
        if (sum) hrefs.push(norm(sum.getAttribute('data-link')));
        if (hrefs.indexOf(trail[d].u) >= 0) pick = navToken(li);
      }
    }
    if (pick) {
      navItems.forEach(function (li) { li.classList.toggle('mh-nav-active', navToken(li) === pick); });
    }
  }

  // What the menus say about a link: the universe (WOMEN / MEN / KIDS / LIFE)
  // and the category column (CLOTHING, SHOES...) it was opened from. Both navs
  // tag their items with the same site-nav__item-<x> token and the desktop
  // markup is always in the DOM, so one lookup serves the megamenu and the
  // phone drawer alike.
  // The menus are typed in capitals (WOMEN, CLOTHING). Beside a collection
  // title like "Women Activewear" that reads as shouting, so give the crumbs
  // taken from a menu the same case as the rest of the trail. Menu labels are
  // single words here, so a plain title-case is enough.
  function tidy(t) {
    t = (t || '').trim();
    if (t !== t.toUpperCase()) return t;
    return t.toLowerCase().replace(/(^|[\s\-&/])([a-z])/g, function (m, pre, ch) {
      return pre + ch.toUpperCase();
    });
  }
  function pathOf(href) {
    try { return norm(new URL(href, location.href).pathname); } catch (err) { return null; }
  }
  function universeCrumb(fromPath, el) {
    var sub = el.closest('.women_sub, .men_sub, .kids_sub, .life_sub');
    var gm = sub ? (' ' + sub.className + ' ').match(/ (women|men|kids|life)_sub /) : null;
    var g = gm ? gm[1] : null;
    if (!g && fromPath) {
      // "women" has to be tested before "men" - it contains it.
      g = /women/.test(fromPath) ? 'women'
        : /(^|[\/-])men([\/-]|$)/.test(fromPath) ? 'men'
        : /kids|boys|girls|baby/.test(fromPath) ? 'kids'
        : null;
    }
    if (!g) return null;
    var links = document.querySelectorAll('.site-navigation > .site-nav__item.main-menu a[href]');
    for (var i = 0; i < links.length; i++) {
      if (links[i].pathname.indexOf('/pages/' + g) >= 0) {
        return { u: norm(links[i].pathname), t: tidy(links[i].textContent), k: 'page' };
      }
    }
    return null;
  }
  function menuSeed(a, path) {
    var tokEl = a.closest('[class*="site-nav__item-"]');
    var token = tokEl ? navToken(tokEl) : null;
    var cat = null;
    if (token) {
      var li = document.querySelector('.sub-menu .site-navigation > .site-nav__item.' + token);
      var sum = li ? li.querySelector('summary[data-link]') : null;
      var catPath = sum ? pathOf(sum.getAttribute('data-link')) : null;
      if (catPath) cat = { u: catPath, t: tidy(sum.textContent), k: 'collection' };
    }
    var out = [];
    var uni = universeCrumb(cat ? cat.u : path, a);
    if (uni && uni.u !== path) out.push(uni);
    if (cat && cat.u !== path) out.push(cat);
    return out.length ? out : null;
  }

  // Site-wide navigation starts a new journey instead of extending this one.
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    // Megamenu titles (CLOTHING...) are <summary data-link>, which the theme
    // turns into a navigation on click.
    var a = e.target.closest('a[href], summary[data-link]');
    if (!a || a.closest('.mh-bc')) return;
    var path;
    try { path = norm(new URL(a.getAttribute('href') || a.getAttribute('data-link'), location.href).pathname); } catch (err) { return; }
    if (a.href && a.origin !== location.origin) return;
    // The predictive/instant panel is sometimes rendered outside the header
    // (the search app owns it), so the header selector alone does not catch a
    // result click. Walk up a few levels for a search container, stopping at
    // the page body so a collection page's own "Search options" filter - which
    // lives inside #MainContent - is never mistaken for it.
    var inSearch = false;
    var hop = a;
    for (var s2 = 0; s2 < 10 && hop && hop !== document.body; s2++) {
      if (hop.id === 'MainContent' || hop.id === 'PageContainer') break;
      if (hop.matches && hop.matches('[class*="predictive"], [class*="search"], [class*="Search"], [id*="search"], [id*="Search"]')) {
        inSearch = true;
        break;
      }
      hop = hop.parentElement;
    }

    if (inSearch || a.closest('.shopify-section-group-header-group, .shopify-section-group-footer-group, #NavDrawer, #CartDrawer, .site-header, .site-footer')) {
      store(FRESH, path);
      store(SEED, menuSeed(a, path));
      var item = a.closest('.site-navigation > .site-nav__item:not(.main-menu)');
      store(NAV, item ? { t: navToken(item), u: path } : null);
    }
  }, true);
})();
